import { TooltipModule } from 'primeng/tooltip';
import { AgendarAtualizacaoComponent } from './../agendar-atualizacao/agendar-atualizacao.component';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtualizacoesDisponiveisComponent } from './atualizacoes-disponiveis.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PaginatorModule } from 'primeng/paginator';
import { CalendarModule } from 'primeng/calendar';


@NgModule({
  imports: [
    CommonModule,
    ToolbarModule,
    TableModule,
    ButtonModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    PaginatorModule,
    CalendarModule,
    TooltipModule 
  ],
  declarations: [
    AtualizacoesDisponiveisComponent,
    AgendarAtualizacaoComponent
  ],
  
  entryComponents: [
    AgendarAtualizacaoComponent
  ]
})
export class AtualizacoesDisponiveisModule { }
